<template>
  <div class="comp-ly-list">
    <jw-spin :loading="loading" :style="{ width: '100%' }">
      <div class="comp-ly-list-quick" v-if="entity != 101 && formRef && objInfo?.name && userInfo?.roles?.indexOf(entity >= 200 ? 'object:custom' : 'object:system') !== -1">
        <component class="comp-ly-list-quick-icon" v-if="objInfo?.icon" :is="objInfo?.icon" />
        <span class="comp-ly-list-quick-title">{{ objInfo?.name }}</span>
        <jw-dropdown @select="selectQuick" position="bl">
          <span class="comp-ly-list-quick-btn hand"><icon-more /></span>
          <template #content>
            <jw-doption :value="1">{{ $t('表单设计') }}</jw-doption>
            <jw-doption :value="3">{{ $t('视图设置') }}</jw-doption>
          </template>
        </jw-dropdown>
      </div>
      <jw-card :bordered="false">
        <template #title>
          <div style="padding-left: 4px">
            <xl-tab style="margin-right: 50px" @cb="getViewId" ref="viewTabRef" :entity="entity"></xl-tab>
          </div>
        </template>
        <div :key="viewId + entity">
          <template v-if="viewId > 0">
            <!-- 分组列表 -->
            <xl-iframe v-if="isFrame" :height="windowHeight" :query="{ entity: entity }" :src="frameData?.pcUrl" />
            <template v-else>
              <template v-if="fieldGroupsIsShow">
                <ly-list-group-layout v-if="fieldGroups?.length" :viewId="viewId" :entityId="entity" :fieldGroups="fieldGroups" ref="lyListLayoutRef" :fieldsListAll="fieldsListAll" :layoutFieldList="layoutFieldList" @cb="getListLayout" :operations="operationsWidth" @cbGroup="openListGroup"> </ly-list-group-layout>
                <ly-list-layout v-else :viewId="viewId" :entityId="entity" :fieldGroups="fieldGroups" ref="lyListLayoutRef" @cb="getListLayout" :operations="operationsWidth" @cbGroup="openListGroup"></ly-list-layout>
              </template>
              <template v-else>
                <fh-list-skeleton></fh-list-skeleton>
              </template>
            </template>
          </template>
          <template v-else>
            <fh-list-skeleton :isFilter="false"></fh-list-skeleton>
          </template>
        </div>
      </jw-card>
      <!-- 编辑对象弹窗（表单设计，表单配置，表单发布） @cb="formCb" -->
      <object-form ref="formRef" @cb="formCb" />
      <fh-add-edit v-if="isMobileLink" ref="addEditRef" @cb="closeForm" />
    </jw-spin>
  </div>
</template>

<script setup>
import { ref, provide, computed, nextTick, defineAsyncComponent, onBeforeUnmount } from 'vue';
import XlIframe from '@/components/xl-iframe/xl-iframe.vue';
const ObjectForm = defineAsyncComponent(() => import('@/views/setting/sys-fields/components/object-form/index.vue'));
import { useRoute } from 'vue-router';
import useLoading from '@/hooks/loading';
import { layoutService } from '@/api/';
import { Message } from '@arco-design/web-vue';
import useEventListener from '@/hooks/event-listener';
const { eventListener } = useEventListener();
import { useFilterListStore, useUserStore } from '@/store';
const useFilterList = useFilterListStore();
const { loading, setLoading } = useLoading(false); //loading
const route = useRoute();
import useViewFields from '@/hooks/view-fields';
import FhListSkeleton from '@/components/fh-list/fh-list-skeleton/fh-list-skeleton.vue';
const { fieldsListAll, layoutFieldList, getLayoutFieldsObject } = useViewFields();

const props = defineProps({
  entityId: {
    //对象的entity【系统对象时必传】
    type: Number || String,
    default: ''
  },
  operations: {
    //操作区域默认宽度是180，如有操作区域宽度请传参数
    type: Number,
    default: 180
  }
});
const { userInfo } = useUserStore(); //用户信息
const entity = computed(() => props.entityId || route?.params?.entity);
console.log(56, route.params);
const operationsWidth = computed(() => props.operations);
const fieldGroups = ref([]);
const fieldGroupsIsShow = ref(false);
/****************视图相关********************** */
const lyListLayoutRef = ref();
const viewId = ref(-1);
const viewsObj = ref(null);
const isFrame = ref(false);
const frameData = ref({}); //外链跳转信息
const windowHeight = ref(window.innerHeight - 120 > 0 ? window.innerHeight - 120 : 200);
const eventListen = () => {
  windowHeight.value = window.innerHeight - 120 > 0 ? window.innerHeight - 120 : 200;
};
eventListener('resize', eventListen);
//兼容移动端链接直接在列表打开新建、编辑、复制的callback
/******************* 移动端链接兼容 start **********************/
const addEditRef = ref();
const isMobileLink = ref(false);
const closeForm = () => {
  isMobileLink.value = false;
};
const compatibleMobile = () => {
  isMobileLink.value = true;
  nextTick(() => {
    const _routeParams = route.params?.id?.split('-');
    const params = {
      id: _routeParams?.[3] || '',
      type: _routeParams?.[0] == 'update' ? 40 : 30,
      viewId: _routeParams?.[2] || -1,
      entity: entity.value,
      copy: _routeParams?.[0] == 'copy' || undefined
    };
    console.log(params);
    addEditRef.value?.open(params);
  });
};
/******************* 移动端链接兼容 end **********************/
// 获取视图ID
const getViewId = async (views) => {
  /***** 外链容器兼容 start *****/
  fieldGroupsIsShow.value = false;
  if (views?.selectTab?.type === '30') {
    viewId.value = views?.viewId;
    const _frameData = JSON.parse(views?.selectTab?.businessData);
    console.log(_frameData, 'console.log(_frameData');
    if (_frameData?.openWith == 1) {
      window.open(_frameData?.pcUrl, '_blank');
    } else {
      frameData.value = _frameData;
      isFrame.value = true;
    }
    return false;
  }
  isFrame.value = false;
  frameData.value = {};
  /***** 外链容器兼容 end *****/
  viewsObj.value = views;
  //给快捷设置布局添加forceRefresh 因为布局返回后需要强制刷新
  if (viewId.value === views.viewId && views?.forceRefresh !== true) return;
  // 获取视图后先清空分组
  fieldGroups.value = [];
  viewId.value = views?.viewId;
  // 获取视图后 立即获取视图下字段
  await getLayoutFieldsObject({
    entity: entity.value,
    viewId: viewId.value || null
  });
  await userListPageConfigGet();
  await lyListLayoutRef.value?.getField?.(views);
  setLoading(true);
  nextTick(async () => {
    if (route.params?.id && !useFilterList.routerBusinessId) {
      if (route.params?.id?.indexOf('-') > -1) {
        //移动端路由兼容
        compatibleMobile();
      } else {
        //获取路由参数id，打开一次详情，下次不再打开
        lyListLayoutRef.value?.toDetails({ id: route.params.id });
        useFilterList.updateRouterBusinessId(route.params.id);
      }
    }
  });
  setLoading(false);
};
/****************视图相关********************** */
// const lyListUniversalButtonsRef = ref();
// const refreshList = (tp) => {
//   if (tp === 'detail') {
//     lyListLayoutRef.value?.getLoadTableList(undefined, false);
//   } else {
//     lyListLayoutRef.value?.loadTList();
//   }
// };
// 筛选条件
// const universalButtonParams = ref({});
const getListLayout = (p) => {
  // if (p.type === 1) {
  //   lyListUniversalButtonsRef.value?.getBtnPermissionObj(p.params);
  // } else if (p.type === 2) {
  //   console.log(76, p.params);
  //   universalButtonParams.value = p.params;
  // } else
  if (p.type === 3) {
    getLoadTableList();
  }
};
const viewTabRef = ref();
const getLoadTableList = () => {
  viewTabRef.value?.setViewId?.();
  lyListLayoutRef.value?.getLoadTableList(undefined, false);
};
// 打开列表
const openListGroup = async () => {
  await userListPageConfigGet();
  await openlist();
};
const openlist = async () => {
  nextTick(() => {
    if (fieldGroups.value?.length) {
      lyListLayoutRef.value?.groupInit(viewsObj.value);
    } else {
      lyListLayoutRef.value?.getField(viewsObj.value);
    }
  });
};
// 获取分组
const userListPageConfigGet = async () => {
  try {
    const params = {
      entity: entity.value,
      viewId: viewId.value
    };
    useFilterList.setFieldsSort([]);
    useFilterList.setFieldsSortDefault([]);
    const json = await layoutService.userListPageConfigGet(params);
    if (!json.error) {
      // 过滤掉 fieldGroups.value  里  fieldStatus  等于2  的
      const res = json.result;
      const resFields = res?.fieldGroups;
      if (resFields && Array.isArray(resFields) && resFields?.length) {
        fieldGroups.value = resFields?.filter((i) => i.fieldStatus != 2);
      } else {
        fieldGroups.value = [];
      }
      console.log('userListPageConfigGet', json);
      // 追加字段排序数据
      // 默认排序字段
      const fieldArray = [];
      const fieldArrayDefault = [];
      const defaultSortList = res?.defaultSortList || [];
      const sortList = res?.sortList || [];
      // 取自定义
      if (sortList && Array.isArray(sortList) && sortList?.length) {
        sortList?.forEach((item) => {
          if (item.fieldStatus == 1) {
            item.isDefault = false;
            fieldArray.push(item);
          }
        });
      }
      useFilterList.setFieldsSort(fieldArray);
      // 自定义为空时取默认
      if (defaultSortList?.length && Array.isArray(defaultSortList)) {
        defaultSortList?.forEach((item) => {
          if (item.fieldStatus == 1) {
            item.isDefault = true;
            fieldArrayDefault.push(item);
          }
        });
      }
      useFilterList.setFieldsSort(fieldArray?.length ? fieldArray : fieldArrayDefault?.length ? fieldArrayDefault : []);
      console.log('4501', JSON.parse(JSON.stringify(useFilterList.fieldsSort)));
      useFilterList.setFieldsSortDefault(fieldArrayDefault || []);
      // 保存排序ID
      if (res?.id) {
        useFilterList.setSortId(entity.value, res?.id);
      }
      fieldGroupsIsShow.value = true;
    } else {
      Message.error(json.error?.msg || '失败，请重试!');
    }
  } catch (e) {
    // Message.error(e.message || e.statusText || '失败，请重试!');
    console.log(e);
  }
};

/************* 快捷打开设置 start **************/

const formRef = ref();
const objInfo = computed(() => {
  const data = userInfo?.menus?.entityResources?.find((item) => entity.value && item?.entity == entity.value);
  return {
    icon: data?.icon ?? '',
    name: data?.title ?? ''
  };
});
const selectQuick = (value) => {
  const params = {
    entity: entity.value,
    name: objInfo.value?.name,
    type: 'addObj', //新建对象自动跳转后的标记，用来做返回刷新列表使用
    key: value
  };
  formRef.value.onOpen(params); //打开弹窗
};
const formCb = () => {
  //2025年02月21日17:07:35产品敲定从表单/布局设置过来直接浏览器刷新
  window.location.reload();
};
/************* 快捷打开设置 end **************/
provide('defaultParams', {
  entity: computed(() => entity.value),
  ruleFields: computed(() => {
    return {};
  }) //规则匹配字段列表【Object】
});
// provide('listGroup', {
//   openListGroup: openListGroup
// });
onBeforeUnmount(() => {
  console.log(1589, 'lyList组件销毁了');
  lyListLayoutRef.value = null;
  viewTabRef.value = null;
  viewTabRef.value = null;
  formRef.value = null;
  isFrame.value = false;
  objInfo.value = null;
  viewId.value = null;
});
</script>
<style scoped lang="less">
@import './ly-list.less';
</style>
